import { Action } from "redux";
import { ApiCallModel } from "../models";
import { AppThunkAction } from ".";
import { Get } from "../api/apiUtils";
import { Reducer } from "redux";
import { WorkPacket, WorkPacketValuesModel } from "../models/WorkPacket";
import { WorkPacketDocument } from "../models/WorkPacket";
import { WorkPacketValue } from "../models/WorkPacket";
import { PersistentDataService } from "../services/PersistentDataService";
import { WorkPacketService } from "../services/WorkPacketService";
import { useHistory } from "react-router";

export interface WorkPacketState {
  workPackets: ApiCallModel<WorkPacket[]>;
  workPacketDocuments: ApiCallModel<WorkPacketDocument[]>;
  workPacketValues: ApiCallModel<WorkPacketValue[]>;
}

export const defaultState = {
  workPackets: { isError: false, isLoading: false, result: [] },
  workPacketDocuments: { isError: false, isLoading: false, result: [] },
  workPacketValues: { isError: false, isLoading: false, result: [] }
} as WorkPacketState;

export interface GetAllWorkPackets {
  type: "GET_WORK_PACKETS";
  payload: ApiCallModel<WorkPacket[]>;
}

export interface GetWPDocuments {
  type: "GET_WP_DOCUMENTS";
  payload: ApiCallModel<WorkPacketDocument[]>;
}

export interface GetWPValues {
  type: "GET_WP_VALUES";
  payload: ApiCallModel<WorkPacketValue[]>;
}

type KnownAction = GetAllWorkPackets | GetWPDocuments | GetWPValues;

export const actionCreators = {
  getAllWorkPackets: (): AppThunkAction<KnownAction> => (dispatch) => {
    dispatch({
      type: "GET_WORK_PACKETS",
      payload: {
        isError: false,
        isLoading: true,
        result: []
      }
    });

    Get(
      `api/workpacket/all/${
        window.location.pathname.indexOf("truck") > 0
          ? `?modality=1`
          : window.location.pathname.indexOf("rail") > 0
          ? `?modality=2`
          : ""
      }`
    )
      .then((result) => result.json())
      .then((result) => {
        PersistentDataService.saveAllWorkPacketsAsync(result as WorkPacket[]);
        dispatch({
          type: "GET_WORK_PACKETS",
          payload: {
            isError: false,
            isLoading: false,
            result: result
          }
        });
      })
      .catch((reason) =>
        dispatch({
          type: "GET_WORK_PACKETS",
          payload: {
            isError: true,
            isLoading: false,
            result: []
          }
        })
      );
  },
  getWPValues:
    (
      lineHandlingNo: string,
      success: (() => void) | undefined = undefined
    ): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_WP_VALUES",
        payload: {
          isError: false,
          isLoading: true,
          result: []
        }
      });
      dispatch({
        type: "GET_WP_DOCUMENTS",
        payload: {
          isError: false,
          isLoading: true,
          result: []
        }
      });

      Get(`api/workpacket/${lineHandlingNo}/values`)
        .then((result) => result.json())
        .then((result) => {
          PersistentDataService.saveWorkPacketValuesAsync(
            lineHandlingNo,
            result
          );
          dispatch({
            type: "GET_WP_VALUES",
            payload: {
              isError: false,
              isLoading: false,
              result: result.values
            }
          });

          dispatch({
            type: "GET_WP_DOCUMENTS",
            payload: {
              isError: false,
              isLoading: false,
              result: result.documents
            }
          });

          if (success) {
            success();
          }
        })
        .catch((reason) => {
          dispatch({
            type: "GET_WP_VALUES",
            payload: {
              isError: true,
              isLoading: false,
              result: []
            }
          });
          dispatch({
            type: "GET_WP_DOCUMENTS",
            payload: {
              isError: true,
              isLoading: false,
              result: []
            }
          });
        });
    },
  setWPValues:
    (values: WorkPacketValue[]): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_WP_VALUES",
        payload: {
          isError: false,
          isLoading: false,
          result: values
        }
      });
    },
  setWPDocuments:
    (documents: WorkPacketDocument[]): AppThunkAction<KnownAction> =>
    (dispatch) => {
      dispatch({
        type: "GET_WP_DOCUMENTS",
        payload: {
          isError: false,
          isLoading: false,
          result: documents
        }
      });
    },
  insertWorkPacketDataLogs:
    (
      lineHandlingNo: string,
      workPacketValues: WorkPacketValue[],
      workPacketDocuments: WorkPacketDocument[]
    ): AppThunkAction<GetWPDocuments> =>
    (dispatch, getState) => {
      WorkPacketService.saveWorkPacketDataLogsAsync(
        lineHandlingNo,
        workPacketValues,
        workPacketDocuments
      );
    }
};

export const reducers: Reducer<WorkPacketState> = (
  state: WorkPacketState | undefined,
  incomingAction: Action
): WorkPacketState => {
  if (state === undefined) {
    return defaultState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case "GET_WORK_PACKETS":
      return { ...state, workPackets: action.payload };
    case "GET_WP_VALUES":
      return { ...state, workPacketValues: action.payload };
    case "GET_WP_DOCUMENTS":
      return { ...state, workPacketDocuments: action.payload };
    default:
      return state;
  }
};
